// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"93b7065b","24":"284a282d","35":"284a282d","476":"93b7065b","671":"93b7065b","771":"93b7065b","790":"93b7065b","837":"93b7065b","925":"93b7065b"}[chunkId] + ".css";
};